import store from '@/store'
import { post } from '@/helpers/api'
import { getQueryParams } from '@/helpers/utils'
import { uuid, getDeviceInfo, generateUserKey } from '@/helperMethods'

export const checkForLoginToken = async () => {
	const params = getQueryParams()
	// if no logintoken, we can skip out
	if (!params.logintoken) return false

	try {
		// compile all of the device-related data
		const device_type =
			params.devicetype || (window.todesktop ? 'DESKTOP' : 'WEB')
		const payload = {
			logintokens: [params.logintoken],
			device: {
				...getDeviceInfo(),
				uuid: uuid(),
				type: device_type,
				osversion: '1.0',
				appversion: '1.0',
			},
		}
		// account for toolbox support users
		if (params.toolboxid) {
			payload.device.toolbox_user_id = parseInt(params.toolboxid, 10)
		}
		// exchange logintoken for an accesstoken via the api
		const { data } = await post('/api/v1/user.tokenlogin', payload)
		if (
			!data.ok ||
			data.invalid?.length ||
			!data.users.length ||
			!data.users[0].accesstoken
		) {
			console.error('/api/v1/user.tokenlogin failed', data)
			return false
		}
		// store all of the user data in the appConfig for later retrieval
		const [{ user, accesstoken: api_token }] = data.users
		user.hasactivity = true
		const persist = params.persist || 'false'
		const userKey = generateUserKey()

		Object.assign(window.appConfig, {
			user,
			api_token,
			userKey: uuid(),
			persist,
			device_type,
			userKey,
		})

		store.auth.set(api_token, null, user, userKey, persist, payload.device.uuid)

		return true
	} catch (e) {
		console.error(e)
		window.prontoAlert.error()
		return false
	}
}
